<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->


<template>
  <div class="wy-configurations-global-configuration">
    <v-jsoneditor v-model="json" :show-btns="false" :exapndedOnStart="true" mode="code" :modes="['code']" @json-change="onJsonChange()" @has-error="onJsonError()" />
    <div v-if="isChanged && !hasError" class="div-confirm-btn"><el-button class="btn-confirm" type="primary" @click="handleUpdateConfigure">Confirm Changes</el-button></div>
  </div>
</template>

<script>
import VJsoneditor from 'vue-json-editor'
import {mapGetters, mapMutations, mapActions} from 'vuex';

//v-jsoneditor
export default {
  modalTitle: 'Global Configuration',
  components: {
      'v-jsoneditor': VJsoneditor
  },

  computed: {
    ...mapGetters(['globalConfig']),

    isChanged() {
      return JSON.stringify(this.json) != JSON.stringify(this.cloneJson)
    }
  },

  data() {
    return {
      json: {},
      cloneJson: {},
      hasError: false,
      preMsgObj: null
    }
  },

  methods: {
    ...mapMutations(['resetDataModel']),
    ...mapActions(['updateGlobalConfiguration', 'createGlobalConfiguration', 'fetchCompanyGlobalConfigurations']),

    async handleUpdateConfigure() {
      let data = {
        key: 'global',
        config: this.json
      }
      this.disabledBtn = true;
      let res = await this.updateGlobalConfiguration(data);
      if(res.status == 200) {
        this.cloneJson = JSON.parse(JSON.stringify(this.json));
        if(this.preMsgObj == null){
          this.preMsgObj = this.$message({
            dangerouslyUseHTMLString: false,
            duration: 1000,
            showClose: true,
            customClass: 'update-success-msg',
            message: 'Updated successfully',
            onClose: ()=>{
              this.preMsgObj = null;
              window.location.reload();
            }
          });
        }
      }
      else{
        if(this.preMsgObj == null){
          this.preMsgObj = this.$message({
            dangerouslyUseHTMLString: false,
            duration: 5000,
            showClose: true,
            customClass: 'update-failed-msg',
            message: 'Update failed',
            onClose: ()=>{
              this.preMsgObj = null;
            }
          });
        }
      }
      this.hasError = false;
    },

    onJsonError() {
      this.hasError = true
    },
    onJsonChange() {
      this.hasError = false
    }
  },

  async created() {
    let glboalConfig = await this.fetchCompanyGlobalConfigurations();
    if(glboalConfig && Object.keys(glboalConfig).length > 0) {
      this.json = glboalConfig;
      this.cloneJson = JSON.parse(JSON.stringify(this.json));
    }
    else {
      this.json = {};
    }
  }
};
</script>

<style lang="scss">
.wy-configurations-global-configuration {
  height: 100%;
  padding: 10px 15px 10px 10px;

  > div {
    height: calc(100% - 60px);

    .jsoneditor-vue {
      height: 100%;
    }
  }

  .div-confirm-btn {
    // display: inline-block;
    float: right;
    padding-top: 20px;
    padding-right: 12px;
    width: 158px;
    .btn-confirm {
      background-color: #214586;
      padding: 7px 30px 7px 30px;
    }
  }
  
  .jsoneditor.jsoneditor-mode-code {
    border: 1px solid #eee;
    border-radius: 3px;
    height: 100%;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    border: 1px solid #E8E8E8;
    border-radius: 10px;
    
    .ace_gutter {
      background-color: #eee;
    }

    .jsoneditor-menu {
      background-color: #E2ECF7;
      border-bottom: #ddd;
      padding: 7px;
      height:43px;

      > button {
        background-color: #214586;
      }

      .jsoneditor-modes {
        display: none;
      }
      .jsoneditor-poweredBy {
        display: none;
      }
    }

    // .ace-jsoneditor.ace_editor {
    //   // font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    // }
    // .ace_text-input {
    //   font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    // }
    // .ace_content {
    //   font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    // }
  }  
}
</style>
